import React from "react";
import Config from "../../../config/main";
import { DepositModeEnum } from "../../../constants/enums/depositMode";
import {t} from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";

export default function cashInTemplate () {
    let {terminalBalance, data: {data}, depositMode} = this.props,
        authData = JSON.parse(sessionStorage.getItem("authData")),
        currency = authData.currency,
        balance = JSON.parse(sessionStorage.getItem("balance")).session_balance;

    return <div className="ticket-results-view-p">
        <CountDownComponent second={30}/>
        {(((terminalBalance === null || terminalBalance === undefined) ? balance : terminalBalance) + data.amount <= Config.main.balanceLimit) && !Config.main.disableTitoCashout && depositMode !== DepositModeEnum.Card ? <>
            <h3>{`${t("Would you like to deposit")} ${Config.useCurrencySymbol ? Config.main.currency[currency] + data.amount : `${data.amount} ${currency}`} ${t("to your account?")}`}</h3>
            <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m"
                                    onClick={this.cashIn()}>
                                {t("Yes")}
                            </button>
                        </div>
                    </li>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m trans-m"
                                    onClick={this.props.closePopup()}>
                                {t("Cancel")}
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </> : <h3>{`${t("Your ticket amount is ")} ${Config.useCurrencySymbol ? Config.main.currency[currency] + " " + data.amount : `${data.amount} ${currency}`}`}</h3>
        }
    </div>;
};